import BlockyHeavyText from "components/custom-texts/blocky-heavy-text";
import BlockyMediumText from "components/custom-texts/blocky-medium-text";
import { X } from "react-bootstrap-icons";
import styles from "assets/shared-stylesheets/sparket-list-item.module.css";

export const CardHeader = ({
  eventName,
  poolName,
  onCancel,
}: {
  eventName: string;
  poolName: string;
  onCancel?: () => void;
}) => (
  <div style={{ display: "flex", justifyContent: "space-between" }}>
    <div>
      <BlockyHeavyText style={{ fontSize: 10 }}>{eventName}</BlockyHeavyText>
      <BlockyHeavyText className={styles.poolNameText}>
        {poolName}
      </BlockyHeavyText>
    </div>
    <div style={{ marginTop: -5, cursor: "pointer" }} onClick={onCancel}>
      <X size={30} />
    </div>
  </div>
);

export const WinConditionRow = ({ winCondition }: { winCondition: string }) => (
  <div style={{ display: "flex", justifyContent: "space-between" }}>
    <div>
      <BlockyHeavyText className={styles.poolCloseDatePrefix}>
        Win Condition:&nbsp;
      </BlockyHeavyText>
      <BlockyMediumText
        style={{ fontSize: 12, display: "inline", lineHeight: 0.5 }}
      >
        {winCondition}
      </BlockyMediumText>
    </div>
  </div>
);

export const Disclaimer = () => (
  <BlockyMediumText style={{ fontSize: 9, color: "gray" }}>
    Expected returns are subject to change based on subsequent activity in the
    pool.
  </BlockyMediumText>
);
